import App from "./App";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";
import { ToastContainer } from "react-toastify";
import { BrowserRouter } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./queries/queryClient";
import "./tailwind.css";
// import "react-toastify/dist/ReactToastify.css";
import Loader from "./utils/Loader";
import ErrorFallback from "./components/ErrorFallback";
const GlobalErrorFallback = ({ error }) => (
  <ErrorFallback error={error} fullPage />
);
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <PersistGate loading={<Loader size="large" />} persistor={persistor}>
      {/* Redux stays the outer provider: it owns client state (auth, the
          selected store, table-column preferences) and is what PersistGate
          rehydrates. React Query sits inside it and owns server state only.
          Nested this way, a query can read the selected store from Redux —
          the reverse is never needed. */}
      <QueryClientProvider client={queryClient}>
        <ErrorBoundary FallbackComponent={GlobalErrorFallback}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ErrorBoundary>
        <ToastContainer />
      </QueryClientProvider>
    </PersistGate>
  </Provider>,
);
